import React from "react";
import { SeparatorMRVProps } from "./SeparatorMRV.types";
import { SeparatorMRVContainer } from "./SeparatorMRV.style";

export default function SeparatorMRV({
  id,
  backgroundColor,
  heightDesktop,
  heightTablet,
  heightMobile,
}: SeparatorMRVProps) {
  return (
      <SeparatorMRVContainer id={id} $backgroundcolor={backgroundColor}
        $heightDesktop={heightDesktop}
        $heightTablet={heightTablet}
        $heightMobile={heightMobile}>
      </SeparatorMRVContainer>
  );
};